import React from 'react'
import { connect } from 'react-redux'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import taRpo01 from '../../images/ta-rpo-01.png'
import taRpo02 from '../../images/ta-rpo-02.png'
import taRpo03 from '../../images/ta-rpo-03.png'
import taRpo04 from '../../images/ta-rpo-04.png'
import { usersGetDetailAsync } from '../../actions/users.js'
import { accesslog } from '../../helpers/global.js'

class TaRpo extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0)
	}

  render() {

    return (
			<div id="ta-ngac">
        <HeaderNewClear isOnStatusFor="is-on" />
        <div className="section-top-solution relative bg-gray" style={{
          position: 'relative',
          paddingTop: '120px',
        }}>
          <div className="gray-curve-bottom-right"></div>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <h1 className='title-1'>
                  NextGen Recruitment Process Outsourcing
                </h1>
                <p className='sub-title-1'>
                  Scalable, Tech-Powered Hiring, Without Building a Team
                </p>
                <p className='text-normal-2'>
                  No internal recruiters? No problem. ASTRNT’s NextGen RPO gives you a complete hiring engine, combining structured interviews, smart assessments, and a dedicated team of experts.
                </p>
                <a className='btn btn-primary-red' onClick={() => {
                  document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                  accesslog('nextgen-rpo', 'button_talk_to_an_expert');
                }}>
                  Talk to an Expert
                </a>
              </div>
            </div>
            <div className='flex-item-right flex-container flex-end align-items-center'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={taRpo01} />
              </div>
            </div>
          </section>
        </div>
        <div className="section-white" style={{overflow: 'hidden'}}>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-right flex-container flex-end align-items-center'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={taRpo02} />
              </div>
            </div>
            <div className='flex-item-left'>
              <div className='vertical-item--center'
                style={{
                  padding: '0 60px',
                }}
              >
                <h1 className='title-2'>
                  We Do the Hiring, So You Can Focus on Growth
                </h1>
                <p className='sub-title-1 text-justify'>
                  Whether you're building a team from scratch, running a graduate program, or scaling fast, we act as your complete hiring partner, doing everything for you.
                </p>
                <ul className='list-1 m-t-25'>
                  <li>
                    <div>
                      <i className="fas fa-check check-white-green" />
                      <p className='text-normal-1'>
                        We handle sourcing, screening, interviewing and shortlisting
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <i className="fas fa-check check-white-green" />
                      <p className='text-normal-1'>
                        All powered by ASTRNT’s AI video interview and assessment platform
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <i className="fas fa-check check-white-green" />
                      <p className='text-normal-1'>
                        Custom workflows built around your role requirements and hiring goals
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>
        <div className="section-white center">
          <div className="table-1-container">
            <table className='table-1'>
              <tr>
                <th>Aspect</th>
                <th>Traditional RPO</th>
                <th>NextGen RPO by ASTRNT</th>
              </tr>
              <tr>
                <td><b>Time to Hire</b></td>
                <td>60-90 days</td>
                <td>14-30 days</td>
              </tr>
              <tr>
                <td><b>Cost per Hire</b></td>
                <td>High due to recruiters hours</td>
                <td>Reduced and optimised</td>
              </tr>
              <tr>
                <td><b>Shortlist Quality</b></td>
                <td>Inconsistent and recruiter-dependent</td>
                <td>Structured, validated, and role-aligned</td>
              </tr>
              <tr>
                <td><b>Process Simplicity</b></td>
                <td>Multiple steps, high coordination load</td>
                <td>Designed to be simple for your team</td>
              </tr>
            </table>
          </div>
        </div>
        <div className="section-white" style={{overflow: 'hidden'}}>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-left'>
              <div className='vertical-item--center'
                style={{
                  padding: '0 60px',
                }}
              >
                <h1 className='title-2'>
                  Behind the NextGen RPO
                </h1>
                <ul className='list-1 m-t-25'>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        <b>Define Role and Success Metrics</b>
                        <p>We work with your team to set hiring criteria and expectations</p>
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        <b>Source and Attract Talent</b>
                        <p>We manage sourcing, outreach, and branding to build your pipeline</p>
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        <b>Run Smart Screening</b>
                        <p>Every candidate goes through video interviews and structured assessments</p>
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        <b>Score and Recommend</b>
                        <p>You receive shortlists with scores, summaries, and supporting insights</p>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className='flex-item-right flex-container flex-end align-items-center'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={taRpo03} />
              </div>
            </div>
          </section>
        </div>
        <div className="section-white" style={{overflow: 'hidden'}}>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-right flex-container flex-end align-items-center'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={taRpo04} />
              </div>
            </div>
            <div className='flex-item-left'>
              <div className='vertical-item--center'
                style={{
                  padding: '0 60px',
                }}
              >
                <h1 className='title-2'>
                  Use Cases We Support
                </h1>
                <ul className='list-1 m-t-25'>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        <b>Graduate Hiring Programs</b>
                        <p>Identify and place future leaders across departments</p>
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        <b>Volume and Hourly Hiring</b>
                        <p>Fill frontline roles with speed and objectivity</p>
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        <b>Specialist or Technical Positions</b>
                        <p>Validate hard skills and role readiness before final interview</p>
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        <b>New Business or Startups</b>
                        <p>Build full teams fast, without heavy investment in full TA infrastructure</p>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>
        <div className="section-white bg-gray center"
          style={{
            textAlign: '-webkit-center',
            minHeight: '366px',
            padding: '56px 0',
            position: 'relative',
          }}
        >
          <div className='gray-triangle-bottom-right'>
            <div className='gray-small-triangle-bottom-right'></div>
          </div>
          <div>
            <h1 className='title-1'>
              Let’s Run Your Hiring Together
            </h1>
            <p style={{
              margin: '20px 0',
            }}>
              You define the target. We build the engine to get you there. With ASTRNT, modern hiring is possible without
              <br />
              building it from scratch.
            </p>
            <div>
              <a className='btn btn-primary-red' onClick={() => {
                document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                accesslog('nextgen-rpo', 'button_talk_to_an_expert');
              }}>
                Talk to an Expert
              </a>
            </div>
          </div>
        </div>
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
    globalGetLanguages:state.globalGetLanguages,
    user: state.user
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
    usersGetDetailAsync: (user) => dispatch(usersGetDetailAsync(user))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TaRpo)
